"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function debounce(f, ms) {
  var _this = this;

  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var fnCall = function fnCall() {
      f.apply(_this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(fnCall, ms);
  };
}

var useDebouncedCallback = function useDebouncedCallback(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var cb = arguments.length > 2 ? arguments[2] : undefined;
  var debounced = debounce(fn, wait);
  return (0, _react.useCallback)(debounced, [debounced, cb]);
};

var _default = useDebouncedCallback;
exports["default"] = _default;